import {
  DETAIL_PROMO,
  INTERSECTION_ITEM_AND_CATEGORY,
  INTERSECTION_ITEM_VARIANTS,
  PROMO_TYPES,
  V1_PROMO_BUY_X_GET_Y,
  V1_PROMO_BUY_X_GET_Y_WITH_OUTLETS
} from './constants'
import moment from 'moment'

let cookiesData = Cookies.get('remember_token')

export function getAllPromoTypes () {
  cookiesData = !cookiesData ? Cookies.get('remember_token') : cookiesData
  return axios.get(PROMO_TYPES, {headers: {Authorization: cookiesData}})
    .then((response) => {
      return Promise.resolve(response)
    })
    .catch((reject) => {
      return Promise.reject(reject)
    })
}

export function getIntersectedItemAndCategories (outletIds) {
  const request = {
    outlet_ids: !outletIds ? null : outletIds
  }
  return axios.post(INTERSECTION_ITEM_AND_CATEGORY, request, {withCredentials: true})
    .then(res => {
      return Promise.resolve(res)
    })
    .catch(rej => {
      return Promise.reject(rej)
    })
}

export function getIntersectedItemVariants (itemName, outletIds) {
  const request = {
    item_name: itemName,
    outlet_ids: outletIds
  }
  return axios.post(INTERSECTION_ITEM_VARIANTS, request, {withCredentials: true})
    .then((response) => {
      return Promise.resolve(response)
    })
    .catch((error) => {
      return Promise.reject(error)
    })
}

export function onCreateNewPromoBuyXGetY (requestBody) {
  cookiesData = !cookiesData ? Cookies.get('remember_token') : cookiesData
  const headers = {
    'time': moment().toISOString(),
    'Authorization': cookiesData
  }
  return axios.post(V1_PROMO_BUY_X_GET_Y, requestBody, {headers: headers})
    .then(response => {
      return Promise.resolve(response)
    })
    .catch(error => {
      return Promise.reject(error)
    })
}

export function getPromoList (params) {
  cookiesData = !cookiesData ? Cookies.get('remember_token') : cookiesData
  params['current_time'] = moment().toISOString()
  return axios.get(V1_PROMO_BUY_X_GET_Y_WITH_OUTLETS, {params, headers: {Authorization: cookiesData}})
    .then(response => {
      return Promise.resolve(response)
    })
    .catch(error => {
      return Promise.reject(error)
    })
}

export function getDetailPromo (promoId) {
  cookiesData = !cookiesData ? Cookies.get('remember_token') : cookiesData
  return axios.get(DETAIL_PROMO(promoId), {headers: {Authorization: cookiesData}})
    .then(response => {
      return Promise.resolve(response)
    })
    .catch(error => {
      return Promise.reject(error)
    })
}

export function deletePromo (promoId) {
  cookiesData = !cookiesData ? Cookies.get('remember_token') : cookiesData
  const headers = {
    'time': moment().toISOString(),
    'Authorization': cookiesData
  }
  return axios.delete(DETAIL_PROMO(promoId), {headers: headers})
    .then(response => {
      return Promise.resolve(response)
    })
    .catch(error => {
      return Promise.reject(error)
    })
}

export function updatePromo (promoId, data) {
  cookiesData = !cookiesData ? Cookies.get('remember_token') : cookiesData
  const headers = {
    'time': moment().toISOString(),
    'Authorization': cookiesData
  }
  return axios.put(DETAIL_PROMO(promoId), data, {headers: headers})
    .then(response => {
      return Promise.resolve(response)
    })
    .catch(error => {
      return Promise.reject(error)
    })
}



// WEBPACK FOOTER //
// ./app/api/libraries/promo/promo.js